import React from 'react';

import GuideVideo from '../../../../components/Video/GuideVideo/GuideVideo';

const PauseModeVideo = (props) => {
    const {isActiveSlide, onError, video, thumbnail, content, onEnded} = props;

    return (
        <GuideVideo
            onError={onError}
            src={video}
            thumbnailSrc={thumbnail}
            autoplay={isActiveSlide}
            isVideoPlay={isActiveSlide}
            isVideoPaused={!isActiveSlide}
            isAnimationFrameAllowed={isActiveSlide}
            content={[content]}
            onEnded={onEnded}
            className='absolute left-1/2 top-1/2 h-full w-full -translate-x-1/2 -translate-y-1/2'
            containerClassName='h-[264px] w-full'
            controlsClassName='m-0 right-2 left-[unset] top-[unset] bottom-2'
        />
    );
};

export default PauseModeVideo;
